module.exports = __webpack_public_path__ + "img/server.a79cf2df.svg";